<!--工单详情-->
<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="工单详情" size="75%" :before-close="handleClose" :visible.sync="drawer"
      direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <!-- 服务商 -->
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class="" style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                    <!-- {{ dataId ? '查看' : '新增' }}工单 -->
                    工单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.orderNo }}</span>
                    <!-- 服务类型 -->
                    <span class="information">{{ formData.serverTypeName }}</span>

                    <!-- 工单状态 -->
                    <span class="information" v-if="formData.stat == 1">登记</span>
                    <span class="information" v-else-if="formData.stat == 2">发布</span>
                    <span class="information" v-else-if="formData.stat == 5">已派网点</span>
                    <span class="information" v-else-if="formData.stat == 6">网点已接单</span>
                    <span class="information" v-else-if="formData.stat == 9">已派师傅</span>
                    <span class="information" v-else-if="formData.stat == 10">师傅已接单</span>
                    <span class="information" v-else-if="formData.stat == 11">已预约</span>
                    <span class="information" v-else-if="formData.stat == 13">已出发</span>
                    <span class="information" v-else-if="formData.stat == 17">已上门</span>
                    <span class="information" v-else-if="formData.stat == 20">完工暂存</span>
                    <span class="information" v-else-if="formData.stat == 30">寄修待确认</span>
                    <span class="information" v-else-if="formData.stat == 31">待寄件</span>
                    <span class="information" v-else-if="formData.stat == 32">已寄待签收</span>
                    <span class="information" v-else-if="formData.stat == 36">待维修</span>
                    <span class="information" v-else-if="formData.stat == 37">修好待寄出</span>
                    <span class="information" v-else-if="formData.stat == 38">客户待签收</span>
                    <span class="information" v-else-if="formData.stat == 40">退换待确认</span>
                    <span class="information" v-else-if="formData.stat == 41">旧机待退回</span>
                    <span class="information" v-else-if="formData.stat == 42">旧机待签收</span>
                    <span class="information" v-else-if="formData.stat == 43">旧机已签收</span>
                    <span class="information" v-else-if="formData.stat == 44">新机待寄出</span>
                    <span class="information" v-else-if="formData.stat == 45">新机已寄出</span>
                    <span class="information" v-else-if="formData.stat == 47">新机待签收</span>
                    <span class="information" v-else-if="formData.stat == 48">新机已签收</span>
                    <span class="information" v-else-if="formData.stat == 49">退换被驳回</span>
                    <span class="information" v-else-if="formData.stat == 61">已完工</span>
                    <span class="information" v-else-if="formData.stat == 62">网点确认完工</span>
                    <span class="information" v-else-if="formData.stat == 63">中心完工审核</span>
                    <span class="information" v-else-if="formData.stat == 64">总部完工审核</span>
                    <span class="information" v-else-if="formData.stat == 91">待结算</span>
                    <span class="information" v-else-if="formData.stat == 92">结算驳回</span>
                    <span class="information" v-else-if="formData.stat == 93">结算中止</span>
                    <span class="information" v-else-if="formData.stat == 94">已结算</span>
                    <span class="information" v-else-if="formData.stat == 97">申请关闭</span>
                    <span class="information" v-else-if="formData.stat == 98">挂起</span>
                    <span class="information" v-else-if="formData.stat == 99">取消</span>
                    <span class="information" v-else></span>
                    <!-- 紧急度 -->
                    <span class="information" v-if="formData.urger == 0">一般</span>
                    <span class="information" v-else-if="formData.urger == 1">紧急</span>
                    <span class="information" v-else-if="formData.urger == 2">特急</span>
                    <span class="information" v-else>未知</span>
                  </div>
                </div>
                <div class="d-cont edit-mce-box">
                  <div class="d-item">
                    <div class="title first" v-if="formData.timeSequences"><b><span>节点图</span></b></div>
                    <div><el-steps :active="timeSeq" align-center finish-status="success" v-if="formData.timeSequences">
                        <el-step :title="item.processName" :description="item.processDate" :key="item.index"
                          v-for="item in formData.timeSequences"></el-step>
                      </el-steps></div>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>受理信息</b></div>
                    <table class="table-detail">
                      <tbody>

                        <tr style="display: block;">
                          <!-- <th>

                    厂商名称
                  :</th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="tenant.userAccount" clearable />
                  </td> -->
                          <!-- <th>工单号:</th>
                          <td>{{ formData.orderNo }}</td>
                          <th>生成方式:</th>
                          <td v-if="formData.createType==0">默认</td>
                          <td v-if="formData.createType==1">客服</td>
                          <td v-if="formData.createType==2">excel</td>
                          <td v-if="formData.createType==3">接口</td>
                          <td v-if="formData.createType==4">公众号</td>
                          <td v-if="formData.createType==5">自建单</td>
                          <td v-if="formData.createType==6">APP自建单</td>
                          <td v-if="formData.createType==7">服务中心</td>
                          <td v-if="formData.createType==9">其它</td>
                          <td v-if="formData.createType==94">苏宁帮客</td>
                          <td v-if="formData.createType==95">京东服务市场</td>
                          <td v-if="formData.createType==97">天猫服务市场</td>
                          <td v-if="formData.createType==98">京东测量服务</td>
                          <td v-if="formData.createType==99">京东ue平台</td>
                          <td v-if="formData.createType==100">京东3C</td> -->

                          <th>姓名/号码:</th>
                          <td>{{ formData.userName }} / {{ formData.userMobile }}</td>
                          <th>用户类型:</th>
                          <td v-if="formData.userType == 0">普通用户</td>
                          <td v-else-if="formData.userType == 1">售前机</td>
                          <td v-else-if="formData.userType == 2">工程机</td>
                          <td v-else-if="formData.userType == 3">VIP用户</td>
                          <td v-else-if="formData.userType == 4">经销商</td>
                          <td v-else></td>
                          <!-- <th>来电号码:</th>
                          <td>{{ formData.userMobile }}</td> -->
                          <th>详细地址:</th>
                          <td style="width: 20vw!important;white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;">
                            {{ formData.userProvice }}{{ formData.userCity }}{{
                              formData.userCounty
                            }}{{ formData.userTown }}{{ formData.userAddress }}
                          </td>
                          <!-- <th style="visibility: hidden;">:</th><td style="visibility: hidden;"></td> -->
                        </tr>
                        <tr style="display: block;">
                          <th>用户档案号:</th>
                          <td>{{ formData.profileId }}</td>
                          <th>工单来源:</th>
                          <td>{{ formData.orderTypeName }}</td>
                          <th>述求:</th>
                          <!-- <td style="width: 20vw!important;white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;">{{ formData.appeals }}</td> -->
                          <td>
                            <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" style="width:20vw"
                              placeholder="暂无内容" v-model="formData.appeals">
                            </el-input>
                          </td>
                        </tr>
                        <tr>
                          <th>
                            服务类型:
                          </th>
                          <td>
                            {{ formData.serverTypeName }}
                          </td>
                          <th>保修类型:</th>
                          <td v-if="formData.guaranteeType == 1"><span class="btn_t">保内</span></td>
                          <td v-else-if="formData.guaranteeType == 2"><span class="btn_f">保外</span></td>
                          <td v-else-if="formData.guaranteeType == 3"><span class="btn_f">未知</span></td>
                          <td v-else></td>


                          <th>工单来源:</th>
                          <td>{{ formData.orderTypeName }}</td>
                          <!-- <th>客诉类型</th>
                        <td>{{ formData.complaintTypeName }}</td> -->
                          <th>督办人:</th>
                          <td>{{ formData.engineerName }}</td>
                        </tr>

                        <tr>

                          <th>录单故障:</th>
                          <td>{{ formData.issueFaultName }}</td>
                          <th>外部订单号:</th>
                          <td>{{ formData.outOrderNo }}</td>
                          <th>工单标签:</th>
                          <td>{{ formData.dispatchStat }}</td>

                          <th>购买渠道:</th>
                          <td>{{ formData.buyChannelName }}</td>
                        </tr>
                        <tr>

                          <th>回访状态:</th>
                          <td v-if="formData.recallStat == 0"><span class="btn_f">未回访</span></td>
                          <td v-if="formData.recallStat == 1"><span class="btn_t">已抽样</span></td>
                          <td v-if="formData.recallStat == 2"><span class="btn_t">已回访</span></td>
                          <td v-if="formData.recallStat == 5"><span class="btn_t">用户已评价</span></td>


                          <th>申诉状态:</th>
                          <td v-if="formData.siteComplainStat == 0"><span class="btn_t">无申诉</span></td>
                          <td v-if="formData.siteComplainStat == 3"><span class="btn_t">待申诉</span></td>
                          <td v-if="formData.siteComplainStat == 5"><span class="btn_t">已申诉</span></td>
                          <td v-if="formData.siteComplainStat == 7"><span class="btn_t">中心已审核</span></td>
                          <td v-if="formData.siteComplainStat == 8"><span class="btn_f">中心驳回</span></td>
                          <td v-if="formData.siteComplainStat == 9"><span class="btn_t">总部已处理</span></td>
                          <td v-if="formData.siteComplainStat == 99"><span class="btn_f">取消</span></td>

                          <th>质检状态:</th>
                          <td v-if="formData.qualityStat == 0"><span class="btn_t">无需质检</span></td>
                          <td v-else-if="formData.qualityStat == 1"><span class="btn_f">待质检</span></td>
                          <td v-else-if="formData.qualityStat == 2"><span class="btn_t">质检通过</span></td>
                          <td v-else-if="formData.qualityStat == 3"><span class="btn_f">质检不通过</span></td>
                          <td v-else></td>
                          <th>配件状态:</th>
                          <td v-if="formData.partsStat == 0"><span class="btn_t">无配件</span></td>
                          <td v-if="formData.partsStat == 1"><span class="btn_t">申请</span></td>
                          <td v-if="formData.partsStat == 2"><span class="btn_t">审核</span></td>
                          <td v-if="formData.partsStat == 3"><span class="btn_t">出库</span></td>
                          <td v-if="formData.partsStat == 4"><span class="btn_t">网点收货</span></td>
                          <td v-if="formData.partsStat == 8"><span class="btn_f">驳回</span></td>
                          <td v-if="formData.partsStat == 9"><span class="btn_f">取消</span></td>
                          <td v-if="formData.partsStat == 11"><span class="btn_t">更换</span></td>
                          <td v-if="formData.partsStat == 12"><span class="btn_t">网点返厂</span></td>
                          <td v-if="formData.partsStat == 13"><span class="btn_t">返厂确认</span></td>
                        </tr>
                        <tr>
                          <th>催单次数:</th>
                          <td>{{ formData.urgeTimes }}</td>

                          <th>投诉次数:</th>
                          <td>{{ formData.complainTimes }}</td>
                          <th>父工单号:</th>
                          <td>{{ formData.parentOrderNo }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-item" style="padding-top: 10px;">
                    <!-- <div class="title first"><b>受理信息</b></div> -->
                    <table class="table-detail">
                      <tbody>
                        <tr>
                          <th>机构名称:</th>
                          <td>{{ formData.orgName }}</td>
                          <th>一级服务商ID:</th>
                          <td>{{ formData.bigSiteId }}</td>
                          <th>网点名称:</th>
                          <td>{{ formData.siteName }}</td>
                          <th>工程师名称:</th>
                          <td>{{ formData.engineerName }}</td>
                        </tr>
                        <tr>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>投诉信息</b></div>
                    <table class="table-detail">
                      <tbody>
                        <div>
                          <tr>
                            <th>投诉对象:</th>
                            <td>{{ formData.soOrderExtendDTO.complaintObjectName }}</td>

                            <th>投诉性质:</th>
                            <td>{{ formData.soOrderExtendDTO.complaintPropertyName }}</td>

                            <th>是否内部转单:</th>
                            <td v-if="formData.soOrderExtendDTO.isIntransfer == 0"><span class="btn_f">否</span></td>
                            <td v-else-if="formData.soOrderExtendDTO.isIntransfer == 1"><span class="btn_t">是</span></td>
                            <td v-else></td>

                            <th>投诉处理满意:</th>
                            <td v-if="formData.soOrderExtendDTO.dealSatisfaction == 0"><span class="btn_f">否</span></td>
                            <td v-else-if="formData.soOrderExtendDTO.dealSatisfaction == 1"><span class="btn_t">是</span>
                            </td>
                            <td v-else></td>
                          </tr>
                          <tr>
                            <th>责任判定:</th>
                            <td>{{ formData.soOrderExtendDTO.dutyJudgeName }}</td>
                            <th>责任细分:</th>
                            <td>{{ formData.soOrderExtendDTO.dutyJudgeSubName }}</td>
                            <th>处理方式:</th>
                            <td>{{ formData.soOrderExtendDTO.handleModelName }}</td>
                            <th>
                              处理方案:
                            </th>
                            <td>
                              <!-- {{ formData.soOrderExtendDTO.handlePlan }} -->

                              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 2 }"
                                style="width:10vw;position: relative;top: 7px;" placeholder="暂无内容"
                                v-model="formData.soOrderExtendDTO.handlePlan">
                              </el-input>

                            </td>
                          </tr>
                        </div>
                      </tbody>
                    </table>
                  </div>
                  <!-- 用户评价 -->
                  <!-- <div class="d-item">
                    <div class="title first"><b>用户评价</b></div>
                    <table class="table-detail">
                      <tbody>
                        <tr>
                          <th>
                            响应速度
                            :</th>
                          <td>
                            <el-rate v-if="formData.soOrderCommentDTO.speed != null"
                              v-model="formData.soOrderCommentDTO.speed" disabled show-score text-color="#ff9900"
                              score-template="{value}">
                            </el-rate>
                          </td>
                          <th>
                            服务效果
                            :</th>
                          <td>
                            <el-rate v-if="formData.soOrderCommentDTO.effect != null"
                              v-model="formData.soOrderCommentDTO.effect" disabled show-score text-color="#ff9900"
                              score-template="{value}">
                            </el-rate>
                          </td>
                          <th>收费评分:</th>
                          <td>
                            <el-rate v-if="formData.soOrderCommentDTO.fee != null" v-model="formData.soOrderCommentDTO.fee"
                              disabled show-score text-color="#ff9900" score-template="{value}">
                            </el-rate>
                          </td>


                        </tr>
                        <tr>
                          <th>
                            总体评价
                            :</th>
                          <td v-if="formData.soOrderCommentDTO == null || formData.soOrderCommentDTO.topLevel == null"></td>
                          <td v-else-if="formData.soOrderCommentDTO.topLevel == 1">非常满意</td>
                          <td v-else-if="formData.soOrderCommentDTO.topLevel == 2">满意</td>
                          <td v-else-if="formData.soOrderCommentDTO.topLevel == 3">一般</td>
                          <td v-else-if="formData.soOrderCommentDTO.topLevel == 4">不满意</td>
                          <td v-else-if="formData.soOrderCommentDTO.topLevel == 5">非常不满意</td>
                          <td v-else></td>

                          <th>
                            评价来源
                            :</th>
                          <td v-if="formData.soOrderCommentDTO == null || formData.soOrderCommentDTO.sources == null"></td>
                          <td v-else-if="formData.soOrderCommentDTO.sources == 1">电商接口</td>
                          <td v-else-if="formData.soOrderCommentDTO.sources == 2">短信回复评价</td>
                          <td v-else-if="formData.soOrderCommentDTO.sources == 3">用户微信评价</td>
                          <td v-else></td>

                          <th>
                            其他评论
                            :</th>
                          <td colspan="4">
                            {{ formData.soOrderCommentDTO.other }}
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div> -->

                  <!-- 服务报告 -->
                  <!-- 业务信息 -->
                  <div class="d-item">
                    <div class="title first"><b>产品信息</b></div>
                    <div>
                      <vxe-table ref="filterTable" :data="formData.soOrderLineDTOList" class="table_item"
                        style="margin:0px auto; width: 95%;" :stripe="true"
                        :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                        :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                        show-overflow height="100" :column-config="{ resizable: true }">
                        <vxe-column type="selection" width="55">
                        </vxe-column>

                        <vxe-column field="itemCode" title="产品编码" />
                        <vxe-column field="itemName" title="产品名称" />
                        <vxe-column field="bigCategoryName" title="产品大类名称" />
                        <vxe-column field="smallCategoryName" title="产品小类名称" />
                        <vxe-column field="qty" title="数量" />
                        <vxe-column field="sitePrice" title="服务费单价" />
                        <vxe-column field="siteFee" title="服务费" width="" />

                      </vxe-table>
                    </div>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>服务内容</b></div>
                    <table class="table-detail" style="display: block;">
                      <tbody style="display: block;">

                        <tr style="display: block;">
                          <!-- <th>故障现象</th>
                        <td>{{ formData.sysmtomName }}</td>

                        <th>故障原因</th>
                        <td>{{ formData.reasonName }}</td> -->

                          <th>完工状态:</th>
                          <td>{{ formData.methodName }}</td>
                          <th>申请保外转保内:</th>
                          <td v-if="formData.outTransIn == 0"><span class="btn_f">否</span></td>
                          <td v-else-if="formData.outTransIn == 1"><span class="btn_t">是</span></td>
                          <td v-else></td>
                        </tr>
                        <tr style="display: block;">
                          <th>
                            完工备注:
                          </th>
                          <td colspan="7">
                            {{ formData.soOrderProcessDTO.finishNote }}
                          </td>
                        </tr>
                        <div class="product" style="">
                          <vxe-table ref="filterTable" :data="formData.soOrderFaultDTOList" class="table_item"
                            style="margin:0px auto; width: 95%;" :stripe="true"
                            :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', fontWeight: '600', color: '#808080', width: '95%' }"
                            :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                            show-overflow height="100" :column-config="{ resizable: true }">
                            <vxe-column type="seq" width="55">
                            </vxe-column>

                            <vxe-column field="symptomName" title="故障现象"></vxe-column>
                            <vxe-column field="reasonName" title="故障原因" />
                            <vxe-column field="methodName" title="服务措施" />
                            <vxe-column field="serverTypeName" title="服务类型" />
                            <vxe-column field="fee" title="费用" />
                            <!-- <vxe-column field="sitePrice" title="服务费单价" />
              <vxe-column field="siteFee" title="服务费"  /> -->

                          </vxe-table>
                        </div>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>配件更换</b>
                      <!--                    <el-button type="primary" class="button-sty btn_zdy" @click="AddListRow1_2()">-->
                      <!--                      <i class="el-icon-plus"></i>-->
                      <!--                      新增-->
                      <!--                    </el-button>-->
                    </div>
                    <div>
                      <div>
                        <vxe-table ref="filterTable" :data="formData.soOrderPartsDTOList" class="table_item"
                          style="margin:0px auto; width: 95%;" :stripe="true"
                          :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                          :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                          show-overflow height="100" :column-config="{ resizable: true }">
                          <vxe-column type="selection" width="55">
                          </vxe-column>

                          <vxe-column field="partsName" title="新配件名称" width="100" />
                          <vxe-column field="oldPartsName" title="旧配件名称" width="100" />
                          <vxe-column field="barcode" title="配件条码" width="100" />
                          <vxe-column field="sitePrice" title="网点价" width="80" />
                          <vxe-column field="qty" title="更换数量" width="80" />
                          <vxe-column field="amount" title="金额" width="80" />
                          <vxe-column field="returnQty" width="110" title="网点返厂数量" />
                          <vxe-column field="returnRevQty" title="返厂数量" width="100" />

                          <!-- 是否可选费用项目 -->
                          <vxe-column field="isNeedReturn" title="是否需要返厂" width="110" />
                          <vxe-column field="isCheck" title="是否需要审核" width="100" />

                        </vxe-table>
                      </div>
                    </div>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>费用结算(服务商)</b> <span class="expense">本单费用:{{
                      formData.soOrderSettleDTO.siteFinalAmount }}</span></div>
                    <table class="table-detail">
                      <tbody>
                        <div>
                          <tr>
                            <th>标准基数:</th>
                            <td>{{ formData.soOrderSettleDTO.standardBase }}</td>
                            <th>服务费用:</th>
                            <td>
                              {{ formData.soOrderSettleDTO.siteAmount }}
                              <el-checkbox v-model="formData.soOrderSettleDTO.siteAmountPass"></el-checkbox>
                              (是否通过)
                            </td>
                          </tr>
                        </div>
                        <div>
                          <tr>
                            <th>
                              区域系数:
                            </th>
                            <td>
                              {{ formData.soOrderSettleDTO.areaCoefficient }}
                            </td>

                            <th>
                              网点星级系数:
                            </th>
                            <td>
                              {{ formData.soOrderSettleDTO.startCoefficient }}
                            </td>

                            <th>满意系数:</th>
                            <td>
                              {{ formData.soOrderSettleDTO.satisfactionCoefficient }}
                            </td>
                          </tr>
                        </div>
                        <div>
                          <tr>
                            <th>
                              红利:
                            </th>
                            <td>
                              {{ formData.soOrderSettleDTO.bonusFee }}
                              <el-checkbox v-model="formData.soOrderSettleDTO.bonusFeePass"></el-checkbox>

                            </td>

                            <th>
                              奖罚:
                            </th>
                            <td>
                              {{ formData.soOrderSettleDTO.rewardAmount }}<span class="Instructions">查看原因</span>
                            </td>

                            <th>远程费用:</th>
                            <td>
                              {{ formData.soOrderSettleDTO.longDistanceAmount }}<span class="Instructions">远程公里</span>
                            </td>

                            <th>
                              特设费用:
                            </th>
                            <td>
                              {{ formData.soOrderSettleDTO.specailAmount }}<span class="Instructions"
                                @click="openRecordDialog(e)">查看凭证</span>
                              <!-- <i class="el-icon-tickets" style="margin-left:10px;color: #00c4b3;"
                            @click="show3 = !show3">详细</i> -->
                            </td>

                          </tr>
                        </div>


                        <div v-for="item in dataList">
                          <tr>
                            <th v-if="item.length > 0">{{ item[0].key }}</th>
                            <td v-if="item.length > 0">{{ item[0].value }}</td>

                            <th v-if="item.length > 1">{{ item[1].key }}</th>
                            <td v-if="item.length > 1">{{ item[1].value }}</td>

                            <th v-if="item.length > 2">{{ item[2].key }}</th>
                            <td v-if="item.length > 2">{{ item[2].value }}</td>

                            <th v-if="item.length > 3">{{ item[3].key }}</th>
                            <td v-if="item.length > 3">{{ item[3].value }}</td>
                          </tr>
                        </div>

                        <!--                      <td>-->
                        <!--                        <el-input type="text" autocomplete="off" v-model="tenant.esiteOrderMan4" clearable/>-->
                        <!--                      </td>-->

                      </tbody>
                    </table>
                    <div>

                      <!--                    <vxe-table ref="filterTable" :data="formData.soOrderFeeAttribute"-->
                      <!--                      style="margin: 1px auto; width: 94%;" :stripe="true"-->
                      <!--                      :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"-->
                      <!--                      :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"-->
                      <!--                      show-overflow height="100" :column-config="{ resizable: true }">-->

                      <!--                      <vxe-column type="seq" width="55"> </vxe-column>-->
                      <!--                      <vxe-column field="feeAttributeId" title="费用类型" width="150" />-->
                      <!--                      <vxe-column field="feeAttributeName" title="费用名称" width="150" />-->
                      <!--                      <vxe-column field="amount" title="金额" width="100" />-->


                      <!--                    </vxe-table>-->
                      <vxe-table ref="filterTable" :data="formData.soOrderSpecailFeeDTOList"
                        style="margin: 1px auto; width: 94%;margin-top: 10px;" :stripe="true"
                        :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                        :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                        show-overflow height="100" :column-config="{ resizable: true }">
                        <vxe-column type="seq" width="55">
                        </vxe-column>

                        <!-- <vxe-column field="itemCode" title="产品编码"/> -->
                        <vxe-column field="feeType" title="类型" width="">
                          <template #default="{ row }">
                            <el-select v-model="row.feeType">
                              <el-option label="向公司申请" :value="1" />
                              <el-option label="向用户收取" :value="2" />
                            </el-select>
                            <!-- <span v-else>{{ row.isCheck }}</span> -->
                          </template>
                        </vxe-column>
                        <vxe-column field="subjectName" title="特设费用名称" />
                        <vxe-column field="qty" title="数量" />
                        <vxe-column field="price" title="单价" />
                        <vxe-column field="amount" title="金额" />
                        <vxe-column field="unit" title="计价单位" />


                      </vxe-table>

                    </div>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>费用结算(用户)</b> <span class="expense">本单合计费用:{{
                      formData.soOrderSettleDTO.siteFinalAmount }}</span></div>
                    <table class="table-detail">
                      <tbody>
                        <tr>
                          <th>优惠金额:</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayDiscount }}
                          </td>
                        </tr>
                        <tr>


                          <th>支付方式:</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayType }}
                          </td>

                          <th>付款方名称:</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayName }}
                          </td>

                          <th>付款方帐号:</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayAccount }}
                          </td>


                          <th>支付流水:</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayNo }}
                          </td>

                        </tr>
                        <tr>
                          <th>支付状态:</th>
                          <td v-if="formData.soOrderSettleDTO == null || formData.soOrderSettleDTO.userPayStat == null"></td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 1">未支付</td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 2">待支付</td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 5">支付成功</td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 8">支付失败</td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 9">支付关闭</td>
                          <td v-else></td>
                          <th>支付时间:</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayTime }}
                          </td>

                          <th>支付备注:</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayStatMsg }}
                          </td>
                          <th>用户付费理由:</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayRemark }}
                          </td>
                        </tr>
                        <tr>
                          <th>付费凭证1:</th>
                          <td>
                            <el-image v-if="formData.soOrderResultDTO.userPayPic1"
                              :src="formData.soOrderResultDTO.userPayPic1" :fit="fit" :preview-src-list="srcList"
                              :initial-index="0"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </td>
                          <th>付费凭证2:</th>
                          <td>
                            <el-image v-if="formData.soOrderResultDTO.userPayPic2"
                              :src="formData.soOrderResultDTO.userPayPic2" :fit="fit" :preview-src-list="srcList"
                              :initial-index="0"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </td>
                          <th>付费凭证3:</th>
                          <td>
                            <el-image v-if="formData.soOrderResultDTO.userPayPic3"
                              :src="formData.soOrderResultDTO.userPayPic3" :fit="fit" :preview-src-list="srcList"
                              :initial-index="0"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div>
                      <vxe-table ref="filterTable" :data="formData.soOrderSpecailFeeDTOList"
                        style="margin: 1px auto; width: 94%;margin-top: 10px;" :stripe="true"
                        :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                        :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                        show-overflow height="100" :column-config="{ resizable: true }">
                        <vxe-column type="seq" width="55">
                        </vxe-column>

                        <!-- <vxe-column field="itemCode" title="产品编码"/> -->
                        <vxe-column field="feeType" title="类型" width="">
                          <template #default="{ row }">
                            <el-select v-model="row.feeType">
                              <el-option label="向公司申请" :value="1" />
                              <el-option label="向用户收取" :value="2" />
                            </el-select>
                            <!-- <span v-else>{{ row.isCheck }}</span> -->
                          </template>
                        </vxe-column>

                        <vxe-column field="subjectName" title="特设费用名称" />
                        <vxe-column field="qty" title="数量" />
                        <vxe-column field="price" title="单价" />
                        <vxe-column field="amount" title="金额" />
                        <vxe-column field="unit" title="计价单位" />


                      </vxe-table>
                    </div>
                  </div>
                  <div class="d-item">
                    <div class="title first"><b>完工资料</b></div>
                    <table class="table-detail">
                      <tbody>
                      <tbody>
                        <div>
                          <tr>
                            <div>
                              <th>机器条码1:</th>
                              <td>
                                {{ formData.soOrderResultDTO.inCode }}
                              </td>

                              <th>机器条码2:</th>
                              <td>
                                {{ formData.soOrderResultDTO.outCode }}
                              </td>

                              <th>生产日期:</th>
                              <td>
                                {{ formData.soOrderResultDTO.productDate }}
                              </td>

                              <th>
                                安装时间
                                :</th>
                              <td>
                                {{ formData.soOrderResultDTO.installDate }}
                              </td>
                            </div>
                          </tr>
                        </div>


                        <tr>
                          <div style="" class="pic_main">
                            <div class="pic_item">
                              <span>图片1：</span>
                              <el-image v-if="formData.soOrderResultDTO.finishPic1"
                                :src="formData.soOrderResultDTO.finishPic1" :fit="fit" :preview-src-list="srcList"
                                :initial-index="0"></el-image>
                              <el-image v-else>
                                <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"
                                    style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                </div>
                              </el-image>
                            </div>

                            <div class="pic_item">
                              <span>图片2:</span>
                              <el-image v-if="formData.soOrderResultDTO.finishPic2"
                                :src="formData.soOrderResultDTO.finishPic2" :fit="fit" :preview-src-list="srcList"
                                :initial-index="1"></el-image>
                              <el-image v-else>
                                <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"
                                    style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                </div>
                              </el-image>
                            </div>
                            <div class="pic_item">
                              <span>图片3:</span>
                              <el-image v-if="formData.soOrderResultDTO.finishPic3"
                                :src="formData.soOrderResultDTO.finishPic3" :fit="fit" :preview-src-list="srcList"
                                :initial-index="2"></el-image>
                              <el-image v-else>
                                <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"
                                    style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                </div>
                              </el-image>
                            </div>
                            <div class="pic_item">
                              <span>图片4:</span>
                              <el-image v-if="formData.soOrderResultDTO.finishPic4"
                                :src="formData.soOrderResultDTO.finishPic4" :fit="fit" :preview-src-list="srcList"
                                :initial-index="3"></el-image>
                              <el-image v-else>
                                <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"
                                    style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                </div>
                              </el-image>
                            </div>
                            <div class="pic_item">
                              <span>图片5:</span>
                              <el-image v-if="formData.soOrderResultDTO.finishPic5"
                                :src="formData.soOrderResultDTO.finishPic5" :fit="fit" :preview-src-list="srcList"
                                :initial-index="4"></el-image>
                              <el-image v-else>
                                <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"
                                    style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                </div>
                              </el-image>
                            </div>
                            <div class="pic_item">
                              <span>图片6:</span>
                              <el-image v-if="formData.soOrderResultDTO.finishPic6"
                                :src="formData.soOrderResultDTO.finishPic6" :fit="fit" :preview-src-list="srcList"
                                :initial-index="5"></el-image>
                              <el-image v-else>
                                <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"
                                    style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                </div>
                              </el-image>
                            </div>
                            <div class="pic_item">
                              <span>图片7:</span>
                              <el-image v-if="formData.soOrderResultDTO.finishPic7"
                                :src="formData.soOrderResultDTO.finishPic7" :fit="fit" :preview-src-list="srcList"
                                :initial-index="6"></el-image>
                              <el-image v-else>
                                <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"
                                    style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                </div>
                              </el-image>
                            </div>
                          </div>
                        </tr>
                        <div>

                        </div>
                      </tbody>
                      </tbody>
                    </table>

                  </div>
                  <div style="height: 10px;"></div>

                </div>


              </el-form>
            </div>
          </div>
        </template>






        <!-- <div class="demo-drawer__footer" style="position: fixed;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">确定</el-button>

        </div> -->
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
// import orderPop from './orderDialog.vue'
import api from "@/api/projectApi";

export default {
  inject: ['reload'],
  name: 'orderDetailDialog',
  props: ['multi', 'row1'],
  components: {

  },
  created() {
    this.dataId = this.row1
    console.log(this.dataId, "传过来的值");
  },
  data() {
    return {
      show3: false,
      dataId: '',
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,
      timeSeq: '',
      drawer: true,
      formData: {
        orderNo: '', // 工单号,前缀"SO"+年月日+6位流水号
        createType: 0, // 生成方式：0默认;1客服;2excel;3接口;4公众号;5PC自建单;6APP自建单;7服务中心;9其它;94苏宁帮客;95京东服务市场;97天猫服务市场;98京东测量服务;99京东ue平台;100京东3C
        orderTypeId: 0, // 工单来源ID,关联bas_order_type.id
        serverTypeId: 0, // 服务类型ID,关联bas_service_type.id
        userType: 0, // 用户类型:0普通用户、1售前机、2工程机、3VIP用户、4经销商
        userName: '', // 用户姓名
        userMobile: '', // 来电号码
        userPhone1: '', // 其他号码1
        userPhone2: '', // 其他号码2
        userProvice: '', // 省
        userCity: '', // 市
        userCounty: '', // 县
        userTown: '', // 镇街
        areaId: 0, // 地区ID,关联bas_area.id
        userAddress: '', // 详细地址
        longitude: 0, // 经度
        latitude: 0, // 纬度
        guaranteeType: 0, // 保修类型：1保内、2保外、3未知
        brandId: 0, // 品牌ID,关联sn_company_brand.id
        buyDate: '', // 购买时间
        buyShop: '', // 购买商场
        invoiceNo: '', // 发票号
        brarcode: '', // 报单条码
        outOrderNo: '', // 外部订单号
        complaintTypeId: 0, // 客诉类型ID,关联bas_customer_complaint_type.id
        issueFaultId: 0, // 客服录单故障现象id,关联bas_fault_symptom.id
        appeals: '', // 述求
        stat: 0, // 状态：1登记;2发布;5已派网点;9已派师傅;13已出发;17已上门;20完工暂存;21已完工;22网点确认完工;23中心确认完工;24总部确认完工;91待结算;92结算驳回;93结算中止;94已结算;98挂起;99取消
        dispatchStat: '', // 工单标签
        partsStat: 0, // 配件状态：0无配件;1申请；2审核；3出库；4网点收货；8驳回；9取消；11更换；12网点返厂；13返厂确认
        recallStat: 0, // 回访状态：0未回访、1已抽样、2已回访;5用户已评价
        siteComplainStat: 0, // 申诉状态：0无申诉；3待申诉；5已申诉；7中心已审核；8中心驳回；9总部已处理；99取消
        qualityStat: 0, // 质检状态：0未质检；1质检通过；2质检不通过；
        orgId: 0, // 业务机构，关联脚手架机构表sys_dept.dept_id
        orgName: '', // 机构名称,冗余字段
        orgIdPath: '', // 机构ID路径,冗余字段.重要
        siteId: 0, // 网点ID,关联sn_user.id;
        siteName: '', // 网点名称,冗余字段
        bigSiteId: null,
        bigSiteName: '',
        engineerId: 0, // 工程师Id,关联sn_site_engineer.id
        engineerName: '', // 工程师名称,冗余字段
        takeTime: null, // 派单时间
        takeEngineerTime: null, // 派工程师时间
        openId: '', // 消费者报修时关联的微信号id
        sysmtomId: 0, // 故障现象id,关联bas_fault_symptom.id
        reasonId: 0, // 故障原因id,关联bas_fault_reason.id
        methodId: 0, // 维修措施id,关联bas_fix_method.id
        isMustRecall: 0, // 是否必访:0否1是
        isCallRecall: 0, // 是否可抽样:0否1是
        isUrgent: 0, // 是否急单:0否1是
        isReplaceFinish: 0, // 是否重新完工：0否1是
        urgeTimes: 0, // 催单次数
        complainTimes: 0, // 投诉次数
        managerId: 0, // 督办人,关联sys_user.id
        outTransIn: 0, // 申请保外转保内:0否1是
        settleId: 0, // 结算单ID,关联sf_batch_settle.id字段
        sendPay: '', // sendPay:打标标识，未定义
        serverTypeName: null,
        orderTypeName: null,
        symptomName: null,
        reasonName: null,
        methodName: null,
        createrNumber: null, // 创建人工号;对应sys_user.username
        addressNumber: null,
        urger: null,

        soOrderExtendDTO: {
          wishBookDate: '', // 期望上门/安装时间
          deliverTime: '', // 到货签收时间
          finishMode: 0, // 完工模式：1结算密码；2上传图片；3图片+条码；9无验证完工
          finishType: 0, // 完工方式:1总部代完工;2网点PC端完工;3网点APP完工;4师傅APP完工;5接口完工;9其他
          commentLevel: 0, // 短信满意度：1非常满意;2满意;3一般;4不满意;5非常不满意
          isSendCommentMessage: 0, // 是否已发送评价短信：0否1是
          qualityMan: '', // 质检人
          qualityDate: '', // 质检时间
          qualityRemark: '', // 质检备注
          secondSiteComplain: 0, // 是否二次申诉：0否1是
          isInstallSynchro: 0, // 是否送装同步：0否1是
          hangupType: 0, // 挂起类型：0总部挂起；1网点挂起
          hangupReason: '', // 挂起原因
          sendFlag: 0, // 外部系统传单标识:0未传;1失败;2已传
          sendMessage: '', // 外部系统传单返回信息
          sendDate: '', // 外部系统传单时间
          thirdSendFlag: 0, // 传第三方网点接口状态:0未传;1失败;2已传
          thirdSendDate: '', // 传第三方网点接口时间
          thirdSendMessage: '', // 传第三方网点接口备注,如失败时用来保存失败的原因
          tmfworderid: '', // 天猫服务市场的工单ID
          tbcustomerid: '', // 天猫服务市场的用户ID
          commercePraise: 0, // 是否电商好评：0否1是

          complaintObjectName: '', // 投诉对象
          complaintProperty: null, // 投诉性质ID,关联脚手架数据字典项目表sys_dict_item.id
          dealSatisfaction: 0,
          dutyJudge: null, // 责任判定ID,关联脚手架数据字典项目表sys_dict_item.id
          dutyJudgeSub: null, // 责任细分ID,关联脚手架数据字典项目表sys_dict_item.id
          handleModel: null, // 处理方式ID,关联脚手架数据字典项目表sys_dict_item.id
          handlePlan: '', // 处理方案
          consultType: null, // 咨询类型ID,关联脚手架数据字典项目表sys_dict_item.id
          consultTypeSub: null, //  咨询细分ID,关联脚手架数据字典项目表sys_dict_item.id
          praiseObjectName: '', //  表扬对象
          praiseType: null, //  表扬类型ID,关联脚手架数据字典项目表sys_dict_item.id
          praiseJudge: 0, //   表扬是否成立:0否1是
          rewardJudge: 0, //  奖励是否成立:0否1是

          complaintPropertyName: null,
          isIntransfer: null,
          dealSatisfactionName: null,
          dutyJudgeName: null,
          dutyJudgeSubName: null,
          handleModelName: null,
          consultTypeName: null,
          consultTypeSubName: null,
          praiseTypeName: null,

        },
        soOrderProcessDTO: {
          orderId: 0, // 工单id，关联so_order.id
          takeOrgTime: '', // 派中心时间
          // takeTime: '', // 派单时间
          acceptOperateTime: '', // 网点确认接单时间
          // takeEngineerTime: '', // 派工程师时间
          engineerAcceptOperateTime: '', // 工程师确认接单时间
          firstBookOperateTime: '', // 首次预约操作时间
          firstBookDate: '', // 首次预约时间
          bookOperateTime: '', // 预约操作时间
          bookDate: '', // 预约时间
          startOffTime: '', // 出发时间
          onDoorTime: '', // 上门签到时间
          onDoorLocation: '', // 上门签到地址
          firstCompleteTime: '', // 首次完工时间
          completeTime: '', // 完工时间
          onTimeLocation: '', // 完工地址
          siteComfirmTime: '', // 网点确认完工时间
          orgComfirmTime: '', // 中心确认完工时间
          officeComfirmTime: '', // 总部确认完工时间
          recallTime: '', // 回访时间
          complaintProcessTimes: 0, // 客诉跟进次数
          complaintProcesser: '', // 客诉跟进人
          complaintProcessDate: '', // 客诉跟进时间
          siteComplaintProcessDate: '', // 网点客诉跟进时间
          applyPayDate: '', // 进入结算池时间
          payDate: '', // 提交结算时间
          cancleDate: '', // 取消/退单时间
          returnId: 0, // 取消/退单原因：关联bas_return_type.id.
          returnName: null, // 取消/退单原因：关联bas_return_type.id.
          finishNote: '', // 完工备注
          comfirmNote: '', // 完工审核备注
          fixStatus: 0,//维修状态
          bookTimes: 0,//预约次数
        },
        soOrderCommentDTO: {
          speed: 0,  // 响应速度评分
          effect: 0,  // 服务效果评分
          fee: 0,  // 合理收费评分
          other: null,  // 其他评价
          pic1: null,  // 图片1
          pic2: null,  // 图片2
          pic3: null,  // 图片3
          topLevel: 0,  // 总体评价:1非常满意;2满意;3一般;4不满意;5非常不满意
          unSatisfiedReasonName: null,  // 不满意原因
          unSatisfiedReasonRemark: null,  // 不满意描述
          question1: null,  // 问题1描述
          question1Answer: 0,  // 问题1答案:0否1是
          question2: null,  // 问题2描述
          question2Answer: 0,  // 问题2答案:0否1是
          question3: null,  // 问题3描述
          question3Answer: 0,  // 问题4答案:0否1是
          question4: null,  // 问题4描述
          question4Answer: 0,  // 问题4答案:0否1是
          sources: 0,  // 评价来源:1电商接口;2短信回复评价;3用户微信评价;4APP扫码评价
        },
        soOrderSettleDTO: {
          siteFinalAmount: null,
          siteAmount: null,
          rewardAmount: null,
          mapLongDistance: null,
          longDistance: null,
          longDistanceAmount: null,
          userPayType: null,
          userPayName: null,
          userPayAccount: null,
          userPayStat: null,
          userPayNo: null,
          userPayTime: null,
          userPayStatMsg: null,
          productDate: null,
          installDate: null
        },
        soOrderResultDTO: {
          inCode: null,
          outCode: null,
          finishPic1: null,
          finishPic2: null,
          finishPic3: null,
          finishPic4: null,
          finishPic5: null,
          finishPic6: null,
        },
        soOrderComplainDTOList: [],
        soOrderLineDTOList: [{}],
        soOrderPartsDTOList: [],
        soOrderPreconditionResultDTOList: [],
        soOrderOperationDTOList: [],
        soOrderSlaList: [],
        sfCheckBillDTOList: [],
        soOrderFaultDTOList: [],
        soOrderFeeAttributeList: [],
        soOrderSpecailFeeDTOList: []
      },
      srcList: [],

    }
  },
  mounted() {
    // this.initTableList();
    this.getData();
    //   console.log(this.tenant, "tenant的值");
    console.log(this.dataId, "_dataId的值");
  },
  methods: {
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        //   this.isEdit = true;
        this.$http({
          url: api.soOrderHistory.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          console.log(this.formData, "this.formData的值市");
          var timeSeqs = this.formData.timeSequences;
          var a = 0;
          for (var i = 0; i < timeSeqs.length; i++) {
            if (timeSeqs[i].processDate != null) {
              a = i;
            }
          }
          this.timeSeq = a + 1;
          this.srcList.push(this.formData.soOrderResultDTO.finishPic1)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic2)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic3)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic4)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic5)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic6)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic7)
          if (this.formData.soOrderComplainDTOList != null && this.formData.soOrderComplainDTOList.length != 0) {
            this.formData.soOrderComplainDTOList.forEach(item => {
              let list = []
              if (item.fileUrl1 != null) {
                list.push(item.fileUrl1)
              }
              if (item.fileUrl2 != null) {
                list.push(item.fileUrl)
              }
              if (item.fileUrl3 != null) {
                list.push(item.fileUrl3)
              }
              item.srcList = list
            })
          }
        })
      } else {
        this.enabled = true;
      }
    },
    // 工单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.orderNo = row.orderNo
      this.formData.orderId = row.orderId
    },
    shut() {
      // this.showOrderPop=true
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }

  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }

    .table-detail tr {
      margin-bottom: 10px;
      display: block;

      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }

      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0, );
      }
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    // right: 20%;
    left: 13vw;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-step__title {
    font-size: 13px !important;
    line-height: 38px;
  }
}

.Instructions {
  text-decoration: underline;
  color: #00c4b3;
  margin-left: 5px;
}
</style>
